import { Stack } from '@customink/pigment-react';
import {
  getTotalDeliveryAmount,
  groupByDesign,
  usePricing,
  useProject,
} from '@customink/project-service-react-components';

import { EditZipCode } from './EditZipCode';
import { LineItem } from './LineItem';

export function DeliveryLineItem() {
  const { data: project } = useProject();
  const projectItemsGroup = groupByDesign(project?.items || []);

  const {
    data: pricingData,
    isLoading: isLoadingPricing,
    isFetching: isFetchingPricing,
  } = usePricing();

  const deliveryAmount = getTotalDeliveryAmount(
    projectItemsGroup,
    pricingData.grouped,
  );

  return (
    <Stack spacing={0.25} useFlexGap>
      <LineItem
        isLoading={isLoadingPricing || isFetchingPricing}
        name="Delivery"
        tagPrefix="delivery"
        value={deliveryAmount.eq(0) ? 'FREE' : `$${deliveryAmount.toFixed(2)}`}
      />
      <EditZipCode />
    </Stack>
  );
}
